import {reportListTypeFromServer, incidentListReportType} from './model'

export const extractDateFromReportListItem = (date: string) => {
  if (!date) return ''
  return date?.split(' ')[0]
}

export const sortTheList = (data: reportListTypeFromServer[]) => {
  const sortedList = [...data]?.sort((a, b) => Number(b.id) - Number(a.id))
  return sortedList
}

export const filterTheIncidentReport = ({report_type}: reportListTypeFromServer) =>
  report_type?.toLowerCase() === 'incident'

export const mapFields = (
  {filename, id, upload_date}: reportListTypeFromServer,
  index: number
): incidentListReportType => ({
  id,
  label: `${index + 1}. ${filename} Date-${extractDateFromReportListItem(upload_date)}`,
  fileName: filename,
  date: upload_date,
})

export const formatIncidentReport = (
  data: reportListTypeFromServer[]
): incidentListReportType[] => {
  const filteredList = data?.filter(filterTheIncidentReport)
  const sortedList = sortTheList(filteredList)
  return sortedList?.map(mapFields)
}
